import {
  ListenerEvent,
  type MessageHandler,
  useNativeMessageListener as useNativeMessagePackageListener
} from '@carvana/merch-native';
import { useContext, useMemo } from 'react';
import { isNonProd } from '~/constants/environment';
import ErrorContext from '~/context/common/ErrorContext';
import { logError } from '~/utilities/errorHandlers';
import {
  useAddFavoriteHandler,
  useCloseModalHandler,
  useRemoveFavoriteHandler,
  useUpdateGeolocationHandler
} from './handlers';
import { useErrorHandler } from '../common/handlers';

export default function useNativeMessageListener() {
  const { setNativeError } = useContext(ErrorContext);
  const addFavoriteHandler = useAddFavoriteHandler();
  const closeModalHandler = useCloseModalHandler();
  const errorHandler = useErrorHandler<ListenerEvent>();
  const removeFavoriteHandler = useRemoveFavoriteHandler();
  const updateGeolocationHandler = useUpdateGeolocationHandler();

  const handlers = useMemo<Array<MessageHandler<ListenerEvent>>>(
    () => [
      addFavoriteHandler,
      closeModalHandler,
      errorHandler,
      removeFavoriteHandler,
      updateGeolocationHandler
    ],
    [
      addFavoriteHandler,
      closeModalHandler,
      errorHandler,
      removeFavoriteHandler,
      updateGeolocationHandler
    ]
  );

  useNativeMessagePackageListener<ListenerEvent>({
    handlers,
    knownEvents: ListenerEvent,
    logErrorToTelemetry: logError,
    logErrorToUser(_err) {
      setNativeError(new Error('Something went wrong. Please try again.'));
    },
    verboseLogs: isNonProd
  });
}
